var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"400px"}},[_c('VueEcharts',{staticStyle:{"height":"100%"},attrs:{"option":_vm.option,"ei":_vm.ei,"theme":"light"},on:{"update:ei":function($event){_vm.ei=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }